"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphFrameChangeSV = exports.TableChangeSV = exports.RowChangeSV = exports.TableChange = exports.RowChange = exports.ParagraphFrameChange = exports.AnchoredPictureChange = exports.LayoutChangeBase = exports.LayoutChangeType = void 0;
var tslib_1 = require("tslib");
var LayoutChangeType;
(function (LayoutChangeType) {
    LayoutChangeType[LayoutChangeType["Deleted"] = 0] = "Deleted";
    LayoutChangeType[LayoutChangeType["Replaced"] = 1] = "Replaced";
    LayoutChangeType[LayoutChangeType["Updated"] = 2] = "Updated";
    LayoutChangeType[LayoutChangeType["Inserted"] = 3] = "Inserted";
})(LayoutChangeType = exports.LayoutChangeType || (exports.LayoutChangeType = {}));
var LayoutChangeBase = (function () {
    function LayoutChangeBase(index, changeType) {
        if (changeType === void 0) { changeType = LayoutChangeType.Updated; }
        this.index = index;
        this.changeType = changeType;
    }
    Object.defineProperty(LayoutChangeBase.prototype, "layoutIndex", {
        get: function () { return this.index; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutChangeBase.prototype, "canvasIndex", {
        get: function () { return this.index; },
        enumerable: false,
        configurable: true
    });
    ;
    LayoutChangeBase.prototype.summarizeChanges = function (_change) {
    };
    return LayoutChangeBase;
}());
exports.LayoutChangeBase = LayoutChangeBase;
var AnchoredPictureChange = (function (_super) {
    tslib_1.__extends(AnchoredPictureChange, _super);
    function AnchoredPictureChange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnchoredPictureChange.prototype.reduceChanges = function () {
        return this.changeType == LayoutChangeType.Updated ? null : this;
    };
    return AnchoredPictureChange;
}(LayoutChangeBase));
exports.AnchoredPictureChange = AnchoredPictureChange;
var ParagraphFrameChange = (function (_super) {
    tslib_1.__extends(ParagraphFrameChange, _super);
    function ParagraphFrameChange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphFrameChange.prototype.reduceChanges = function () {
        return this.changeType == LayoutChangeType.Updated ? null : this;
    };
    return ParagraphFrameChange;
}(LayoutChangeBase));
exports.ParagraphFrameChange = ParagraphFrameChange;
var RowChange = (function (_super) {
    tslib_1.__extends(RowChange, _super);
    function RowChange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowChange.prototype.reduceChanges = function () {
        return this.changeType == LayoutChangeType.Updated ? null : this;
    };
    return RowChange;
}(LayoutChangeBase));
exports.RowChange = RowChange;
var TableChange = (function (_super) {
    tslib_1.__extends(TableChange, _super);
    function TableChange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableChange.prototype.reduceChanges = function () {
        return this.changeType == LayoutChangeType.Updated ? null : this;
    };
    return TableChange;
}(LayoutChangeBase));
exports.TableChange = TableChange;
var RowChangeSV = (function (_super) {
    tslib_1.__extends(RowChangeSV, _super);
    function RowChangeSV(layoutIndex, canvasIndex, changeType) {
        var _this = _super.call(this, canvasIndex, changeType) || this;
        _this._layoutIndex = layoutIndex;
        return _this;
    }
    Object.defineProperty(RowChangeSV.prototype, "layoutIndex", {
        get: function () { return this._layoutIndex; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(RowChangeSV.prototype, "canvasIndex", {
        get: function () { return this.index; },
        enumerable: false,
        configurable: true
    });
    ;
    return RowChangeSV;
}(RowChange));
exports.RowChangeSV = RowChangeSV;
var TableChangeSV = (function (_super) {
    tslib_1.__extends(TableChangeSV, _super);
    function TableChangeSV(layoutIndex, canvasIndex, changeType) {
        var _this = _super.call(this, canvasIndex, changeType) || this;
        _this._layoutIndex = layoutIndex;
        return _this;
    }
    Object.defineProperty(TableChangeSV.prototype, "layoutIndex", {
        get: function () { return this._layoutIndex; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(TableChangeSV.prototype, "canvasIndex", {
        get: function () { return this.index; },
        enumerable: false,
        configurable: true
    });
    ;
    return TableChangeSV;
}(TableChange));
exports.TableChangeSV = TableChangeSV;
var ParagraphFrameChangeSV = (function (_super) {
    tslib_1.__extends(ParagraphFrameChangeSV, _super);
    function ParagraphFrameChangeSV(layoutIndex, canvasIndex, changeType) {
        var _this = _super.call(this, canvasIndex, changeType) || this;
        _this._layoutIndex = layoutIndex;
        return _this;
    }
    Object.defineProperty(ParagraphFrameChangeSV.prototype, "layoutIndex", {
        get: function () { return this._layoutIndex; },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(ParagraphFrameChangeSV.prototype, "canvasIndex", {
        get: function () { return this.index; },
        enumerable: false,
        configurable: true
    });
    ;
    return ParagraphFrameChangeSV;
}(ParagraphFrameChange));
exports.ParagraphFrameChangeSV = ParagraphFrameChangeSV;
